import React from 'react'

const NumberParam = ({ value, onChange, children, step=1 }) => {
    return (
        <div className='flex mb2'>
            <input className='w-30' type='number'
                id={children}
                step={step}
                value={value}
                onChange={onChange}
            />
            <label htmlFor={children} className='f6 flex pa2'>{children}</label>
        </div>
    )
}


export default NumberParam



// WEBPACK FOOTER //
// ./src/components/NumberParam.js